<template>
  <div>
    <v-footer padless>
      <v-col class="text-center" cols="12">
        <small>
          Link Logistics © {{ new Date().getFullYear() }} -

          <v-btn text @click="openChangeLog = true">
            {{ version }}
          </v-btn></small
        >
      </v-col>
    </v-footer>

    <ChangeLog :open.sync="openChangeLog" @close="openChangeLog = false" />
  </div>
</template>

<script>
import ChangeLog from './ChangeLog.vue';
export default {
  name: 'Footer',
  components: {
    ChangeLog
  },
  data: () => ({
    openChangeLog: false
  }),
  computed: {
    version() {
      return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : '1.0.0';
    }
  }
};
</script>

<style></style>
